import $ from 'jquery'
import moment from 'moment'

function removeWeekends(date) {
    const minDay = date.day()

    // If min date falls on Saturday or Sunday, push to Monday
    if (minDay === 6 || minDay === 0) {
        date = date.add( minDay === 6 ? 2 : 1, 'days')
    }
}

function setMinDate(types, $dateField, $typeField) {
    const currentType = types.filter((t) => {
        return t.value == $typeField.val()
    })
    if (currentType.length) {
        const minDays = currentType[0]['min']
        let minDate = moment().add(minDays, 'days')

        removeWeekends(minDate)
        $dateField.datepicker('option', 'minDate', minDate.toDate())

        let consecDate = minDate.clone();

        // Set consecutive dates for the other date fields
        for ( let i = 0; i < $dateField.length; i++) {
            const $field = $( $dateField.get(i) )

            consecDate.add(i === 0 ? 0 : 1, 'days')
            removeWeekends(consecDate);
            
            // Set the date value
            $field.val(consecDate.format('DD/MM/YYYY'))
        }
        return minDate
    } else {
        return false
    }
}

export default () => {

    // eslint-disable-next-line
    if (typeof BOOKING_FORMS === 'undefined') {
        return;
    }

    // Loop through each booking form and setup dynamic minimum date logic
    // eslint-disable-next-line
    BOOKING_FORMS.forEach(function(form) {
        const { form_id, types } = form
        const $form = $('#gform_' + form_id)

        if ($form.length) {
            const $typeField = $form.find('.js-booking-type-field select')
            const $dateField = $form.find('.js-booking-date-field input[type="text"]')
            const hasRequiredFields = $typeField.length && $dateField.length

            if (hasRequiredFields) {
                const dateFieldId = $dateField.attr('name').replace('input_', '')

                // eslint-disable-next-line
                gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {

                    if (formId == form_id) {
                        // Turn off autocomplete because it gets in the way of the datepicker
                        $('#input_' + formId + '_' + fieldId).attr("autocomplete", "off")

                        // Set options
                        optionsObj.changeMonth = false
                        optionsObj.changeYear = false

                        //disable weekends
                        optionsObj.firstDay = 1;
                        optionsObj.beforeShowDay = $.datepicker.noWeekends;

                        // Set initial min date
                        if (fieldId == dateFieldId) {
                            const minDate = setMinDate(types, $dateField, $typeField)
                            if (minDate) {
                                optionsObj.minDate = minDate.toDate()
                            }
                        }
                    }

                    return optionsObj

                })

                // When type field changes update min date accordingly
                $typeField.on('change', () => {
                    setMinDate(types, $dateField, $typeField)
                })

            }
        }

    })

    $(document).bind('gform_post_render', function () {
        $('.cta-form__form .gfield_label').each(function () {
            const $this = $(this)

            if ($this.text() == '*') {
                $this.addClass('hidden')
            }
        })
    })

    const filterSelects = document.querySelectorAll('.js-filter-select')

    if (filterSelects) {
        filterSelects.forEach(select => {
            select.addEventListener('change', () => {
                window.location.href = select.value
            })
        })
    }

    /// Do not submit search form if nothing in the inputbox.
    const $searchForms = $('.js-search-header__form')
    
    $searchForms.on('keyup', (event) => {
        // keyCode 13 is Enter key on the keyboard.
        if (event.target.value == '' && event.originalEvent.keyCode == 13) {
            event.preventDefault();
        }
    })

}
